import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import QuickFilter from 'components/atoms/GefMui/QuickFilter';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { EMPTY_VALUES } from 'constants/general';
import collapsibleTable from 'features/common/collapsibleTable';
import { subheaders } from 'features/common/Subheader/constants';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { setVisibleState } from 'features/common/Subheader/slice';
import {
	changeQuickFilter,
	loadWithQuickFilter,
	resetNextSevenDaysPills,
	setSortValue,
} from 'features/views/marketPlace/actions';
import { quickFilter, quickFilterTypesSetup } from 'features/views/marketPlace/constants';
import { getQuickFilterState } from 'features/views/marketPlace/selectors';

export const Toolbar = () => {
	const dispatch = useDispatch();
	const quickFilterState = useSelector(getQuickFilterState);
	const visibleState = useSelector((state) => getVisibleStateById(state, subheaders.marketPlace));

	const handleFilterChange = useCallback(
		(type) => {
			dispatch(setVisibleState({ id: subheaders.marketPlace, visible: false }));
			dispatch(collapsibleTable.actions.removeOpenedRows('MarketPlaceLeadsTable'));
			dispatch(setSortValue(EMPTY_VALUES.STRING));
			if (quickFilterState !== quickFilter.FUTURE && type === quickFilter.FUTURE) {
				dispatch(resetNextSevenDaysPills());
			}
			dispatch(changeQuickFilter(type));
			dispatch(loadWithQuickFilter(type));
		},
		[dispatch, quickFilterState],
	);

	return (
		<ToolbarTemplate
			leftSide={
				<QuickFilter
					quickFilterState={quickFilterState}
					quickFilterTypesSetup={quickFilterTypesSetup}
					subheaderOpen={visibleState}
					onChange={handleFilterChange}
				/>
			}
		/>
	);
};

export default Toolbar;
